export const environment = {
    production: false,
    apiUrl: 'https://api.euromoselle.qual.cawita.com',
    assetUrl: 'https://assets.euromoselle.qual.cawita.com',
    customerSpaceUrl: 'https://share.euromoselle.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LccjzQqAAAAAB1Qnsa7DHRvUR1VMDKSFnIejSrw'
};